(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  if (window.bmCartPageInit) return;
  window.bmCartPageInit = true;

  function updateLine(input, quantity) {
    var form = input.closest('form.bm-cart-page');
    if (!form || form.dataset.submitting === 'true') return;
    form.dataset.submitting = 'true';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: input.getAttribute('data-line-key'), quantity: quantity }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        window.location.reload();
      })
      .catch(function () {
        form.dataset.submitting = '';
        var error = form.querySelector('[data-cart-error]');
        if (!error) return;
        error.textContent = error.getAttribute('data-message') || '';
        error.classList.remove('hidden');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-qty]');
    if (!button) return;
    var form = button.closest('form.bm-cart-page');
    if (!form) return;
    var input = button.parentElement.querySelector('[data-cart-qty-input]');
    if (!input) return;
    var current = parseInt(input.value, 10);
    if (!isFinite(current)) current = 0;
    var next = current + Number(button.getAttribute('data-cart-qty'));
    if (next < 0) next = 0;
    input.value = String(next);
    updateLine(input, next);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-qty-input]');
    if (!input) return;
    if (!input.closest('form.bm-cart-page')) return;
    var value = parseInt(input.value, 10);
    if (!isFinite(value) || value < 0) value = 0;
    input.value = String(value);
    updateLine(input, value);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
